import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from 'material-react-table'
import React from "react";
import { Edit, History } from "@mui/icons-material";
import InventoryModal from "../../../components/modals/InventoryModal";

function TableInventory(props) {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleHistoryClick = (row) => {
    console.log("History icon clicked for row:", row.original);
    setOpen(true);
  };
  return (
    <>
      <MaterialReactTable
        enableStickyHeader
        muiTableContainerProps={{ sx: { maxHeight: "500px" } }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            size: 120,
          },
        }}
        columns={props.columns}
        data={props.tableData}
        editingMode="modal"
        enableColumnOrdering
        enableEditing
        onEditingRowSave={props.handleSaveRowEdits}
        onEditingRowCancel={props.handleCancelRowEdits}
        renderRowActions={({ row, table }) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            <Tooltip arrow placement="right" title="History">
              <IconButton onClick={() => handleHistoryClick(row)}>
                <History />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        renderTopToolbarCustomActions={() => (
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            alignItems="flex-start"
            margin={"5px"}
          >
            <Button
              onClick={() => props.setCreateModalOpen(true)}
              variant="contained"
              style={{ marginBottom: "10px", marginRight: "10px" }} // Add margin between buttons
            >
              ADD INVENTORY
            </Button>

            <Button
              onClick={() => props.setSubtractModalOpen(true)}
              style={{
                backgroundColor: "#1976D2",
                color: "white",
              }}
              variant="contained"
            >
              Subtract Inventory
            </Button>
          </Box>
        )}
      />
      <InventoryModal open={open} handleClose={handleClose} />
    </>
  );
}

export default TableInventory;
